export default __webpack_public_path__ + "ca38e2a548132dc8544eb30a15522a0b.png";